<ct-extraction-warning text="Im Fall sind bereits DRG vorhanden. Hover für mehr Informationen.">
  <ng-template #tooltip>
    @let overview = proof301Overview();
    <div class="flex flex-col gap-1">
      <span class="font-bold underline">DRG</span>
      <div class="grid grid-cols-[min-content_auto] gap-x-3">
        @for (drg of overview.drgs; track $index) {
          <span class="text-nowrap">{{ drg.code }}</span>
          <span>{{ drg.from }} - {{ drg.to }}</span>
        }
      </div>
      <br />
      <span class="font-bold">{{ overview.diagnoseCount }} Diagnosen</span>
      <span class="font-bold">{{ overview.opsCount }} OPS</span>
    </div>
  </ng-template>
</ct-extraction-warning>
